export default __webpack_public_path__ + "static/media/icon-header-failed.72cf8335.svg";